export default __webpack_public_path__ + "static/media/not-supported-browser.icon.6daf013f.svg";